import axios from 'axios';

const API_BASE_URL = 'https://max1-funding-arb.uc.r.appspot.com';

export const login = async () => {
  throw new Error('Wallet login required.');
};

export const refreshToken = async () => {

  const refresh_token = localStorage.getItem('refreshToken');
  const response = await axios.post(`${API_BASE_URL}/refresh`, { refresh_token });
  const { access_token } = response.data;
  localStorage.setItem('accessToken', access_token);
  localStorage.setItem('tokenExpiry', Date.now() + 2400 * 1000); // Reset expiry to 1 hour
};

export const getAccessToken = async () => {
  const accessToken = localStorage.getItem('accessToken');
  if (!accessToken) {
    localStorage.setItem('isAuthenticated', JSON.stringify(false));
    window.location.href = '/admin';
    return null;
  }
  const expiry = Number(localStorage.getItem('tokenExpiry') || 0);
  if (!expiry || Date.now() > expiry) {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('tokenExpiry');
    localStorage.setItem('isAuthenticated', JSON.stringify(false));
    window.location.href = '/admin';
    return null;
  }
  return localStorage.getItem('accessToken');
};
